export default {
    title: 'Saplings',
    'placeholder': 'Saplings',
 
   
 
  };